export function HuiBreadcrumb() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {},
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <nav class="hui hui-breadcrumb" aria-label="breadcrumb">
                    <ol ng-transclude></ol>
                </nav>
            `;
        }
    }
}

export function HuiBreadcrumbItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            isCurrent: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <li class="hui-breadcrumb-item"
                    ng-class="{'active': $huiCtrl.isCurrent === 'true'}">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <ng-transclude /> 
                </li>
            `;
        }
    }
}

export function HuiBreadcrumbLink() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            color: '@',
            as: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            const tagName = $attrs.as === 'link' ? 'a' : 'span';
            const colorClass = $attrs.as === 'link' ? 'hui-' + ($attrs.color || 'accent') : '';
            return `
               <${tagName} class="hui-breadcrumb-link ${colorClass}" ng-transclude></${tagName}>
            `;
        }
    }
}